<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="County Property Management System -  County" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18"> COUNTY PROPERTY REGISTRY</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">PROPERTY REGISTRY</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Statistics Cards -->
            <div class="row mb-4">
              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Total Properties</p>
                        <h4 class="mb-0">{{ formatNumber(statistics.totalProperties) }}</h4>
                      </div>
                      <div class="text-primary ms-auto">
                        <i class="ri-building-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Available</p>
                        <h4 class="mb-0 text-success">{{ formatNumber(statistics.available) }}</h4>
                      </div>
                      <div class="text-success ms-auto">
                        <i class="ri-checkbox-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Allocated</p>
                        <h4 class="mb-0 text-warning">{{ formatNumber(statistics.allocated) }}</h4>
                      </div>
                      <div class="text-warning ms-auto">
                        <i class="ri-user-settings-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Under Maintenance</p>
                        <h4 class="mb-0 text-info">{{ formatNumber(statistics.maintenance) }}</h4>
                      </div>
                      <div class="text-info ms-auto">
                        <i class="ri-tools-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Decommissioned</p>
                        <h4 class="mb-0 text-danger">{{ formatNumber(statistics.decommissioned) }}</h4>
                      </div>
                      <div class="text-danger ms-auto">
                        <i class="ri-close-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Monthly Revenue</p>
                        <h4 class="mb-0">{{ formatPrice(statistics.monthlyRevenue) }}</h4>
                      </div>
                      <div class="text-success ms-auto">
                        <i class="ri-money-dollar-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex gap-2 flex-wrap">
                  <button v-if="getRight('REGISTER PROPERTY')"
                          @click="openPropertyModal()"
                          class="btn btn-primary">
                    <i class="mdi mdi-plus-circle-outline me-1"></i>
                    Register Property
                  </button>
                  <button v-if="getRight('BULK REGISTER')"
                          @click="openBulkUpload"
                          class="btn btn-info">
                    <i class="mdi mdi-cloud-upload-outline me-1"></i>
                    Bulk Register
                  </button>
                  <button v-if="getRight('PROPERTY ALLOCATION')"
                          @click="openAllocationModal()"
                          class="btn btn-success">
                    <i class="mdi mdi-account-plus-outline me-1"></i>
                    Allocate Property
                  </button>
                  <button v-if="getRight('MAINTENANCE SCHEDULE')"
                          @click="openMaintenanceSchedule"
                          class="btn btn-warning">
                    <i class="mdi mdi-calendar-clock me-1"></i>
                    Maintenance Schedule
                  </button>
                  <button v-if="getRight('PROPERTY REPORTS')"
                          @click="generatePropertyReports"
                          class="btn btn-secondary">
                    <i class="mdi mdi-file-chart me-1"></i>
                    Property Reports
                  </button>
                </div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header with Tabs -->
                  <div class="card-header bg-white border-bottom">
                    <ul class="nav nav-tabs card-header-tabs" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#all-properties" role="tab">
                          <i class="mdi mdi-view-grid me-1"></i>
                          All Properties ({{ filteredProperties.length }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#market-stalls" role="tab">
                          <i class="mdi mdi-store me-1"></i>
                          Market Stalls ({{ getPropertyCount('MARKET_STALL') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#county-houses" role="tab">
                          <i class="mdi mdi-home me-1"></i>
                          County Houses ({{ getPropertyCount('COUNTY_HOUSE') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#machinery" role="tab">
                          <i class="mdi mdi-truck me-1"></i>
                          Machinery ({{ getPropertyCount('MACHINERY') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#equipment" role="tab">
                          <i class="mdi mdi-tools me-1"></i>
                          Equipment ({{ getPropertyCount('EQUIPMENT') }})
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Property Type Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Type:</label>
                        <select v-model="filters.propertyType" @change="filterProperties" class="form-select">
                          <option value="">All Types</option>
                          <option value="MARKET_STALL">Market Stall</option>
                          <option value="COUNTY_HOUSE">County House</option>
                          <option value="MACHINERY">Machinery</option>
                          <option value="EQUIPMENT">Equipment</option>
                          <option value="VEHICLE">Vehicle</option>
                          <option value="LAND">Land</option>
                        </select>
                      </div>

                      <!-- Status Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Status:</label>
                        <select v-model="filters.status" @change="filterProperties" class="form-select">
                          <option value="">All Status</option>
                          <option value="AVAILABLE">Available</option>
                          <option value="ALLOCATED">Allocated</option>
                          <option value="MAINTENANCE">Maintenance</option>
                          <option value="DECOMMISSIONED">Decommissioned</option>
                        </select>
                      </div>

                      <!-- Location Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select v-model="filters.subCounty" @change="filterProperties" class="form-select">
                          <option value="">All Sub Counties</option>
                          <option v-for="subCounty in subCounties" :key="subCounty" :value="subCounty">
                            {{ subCounty }}
                          </option>
                        </select>
                      </div>

                      <!-- Ward Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select v-model="filters.ward" @change="filterProperties" class="form-select">
                          <option value="">All Wards</option>
                          <option v-for="ward in wards" :key="ward" :value="ward">
                            {{ ward }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-4">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by property ID, name, location...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tab Content -->
                  <div class="tab-content">
                    <!-- All Properties Tab -->
                    <div class="tab-pane fade show active" id="all-properties" role="tabpanel">
                      <div class="card-body p-0">
                        <div class="table-responsive">
                          <table class="table table-hover mb-0">
                            <thead class="table-dark">
                            <tr>
                              <th class="text-nowrap">NO.</th>
                              <th class="text-nowrap">Property Details</th>
                              <th class="text-nowrap">Property ID</th>
                              <th class="text-nowrap">Type</th>
                              <th class="text-nowrap">Location</th>
                              <th class="text-nowrap">Current Occupant</th>
                              <th class="text-nowrap text-end">Monthly Rate</th>
                              <th class="text-nowrap">Status</th>
                              <th class="text-nowrap">Last Updated</th>
                              <th class="text-nowrap">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(property, index) in paginatedProperties" :key="property.id">
                              <td class="text-nowrap">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                              <td style="min-width: 250px;">
                                <div class="d-flex align-items-center">
                                  <div class="avatar-sm rounded-circle me-3" :class="getPropertyIconClass(property.type)">
                                    <span class="avatar-title rounded-circle text-white">
                                      <i :class="getPropertyIcon(property.type)"></i>
                                    </span>
                                  </div>
                                  <div>
                                    <strong>{{ property.name }}</strong>
                                    <small class="text-muted d-block">{{ property.description }}</small>
                                    <small class="text-muted d-block">
                                      Size: {{ property.size }} | Condition: {{ property.condition }}
                                    </small>
                                  </div>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <span class="fw-bold">{{ property.propertyId }}</span>
                              </td>
                              <td class="text-nowrap">
                                <span class="badge" :class="getPropertyTypeClass(property.type)">
                                  {{ formatPropertyType(property.type) }}
                                </span>
                              </td>
                              <td class="text-nowrap">
                                <div>
                                  <div>{{ property.subCounty }}</div>
                                  <small class="text-muted">{{ property.ward }}</small>
                                  <small class="text-muted d-block">{{ property.specificLocation }}</small>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <div v-if="property.currentOccupant">
                                  <div class="fw-bold">{{ property.currentOccupant.name }}</div>
                                  <small class="text-muted">{{ property.currentOccupant.phone }}</small>
                                  <small class="text-muted d-block">
                                    Since: {{ property.currentOccupant.allocatedDate }}
                                  </small>
                                </div>
                                <span v-else class="text-muted">Unoccupied</span>
                              </td>
                              <td class="text-nowrap text-end">
                                <span class="fw-semibold">{{ formatPrice(property.monthlyRate) }}</span>
                              </td>
                              <td class="text-nowrap">
                                <span class="badge" :class="getStatusClass(property.status)">
                                  {{ property.status }}
                                </span>
                              </td>
                              <td class="text-nowrap">{{ property.lastUpdated }}</td>
                              <td class="text-nowrap">
                                <div class="d-flex gap-1">
                                  <button @click="viewPropertyDetails(property)"
                                          class="btn btn-primary btn-sm"
                                          data-bs-toggle="modal"
                                          data-bs-target="#propertyDetailsModal">
                                    <i class="mdi mdi-eye"></i>
                                  </button>
                                  <button @click="openPropertyModal(property)"
                                          class="btn btn-outline-secondary btn-sm">
                                    <i class="mdi mdi-pencil"></i>
                                  </button>
                                  <div class="dropdown">
                                    <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                            data-bs-toggle="dropdown">
                                      <i class="bx bx-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                      <li v-if="property.status === 'AVAILABLE'">
                                        <a class="dropdown-item" @click="allocateProperty(property)">
                                          <i class="mdi mdi-account-plus me-2"></i>Allocate
                                        </a>
                                      </li>
                                      <li v-if="property.status === 'ALLOCATED'">
                                        <a class="dropdown-item" @click="terminateAllocation(property)">
                                          <i class="mdi mdi-account-minus me-2"></i>Terminate Allocation
                                        </a>
                                      </li>
                                      <li><a class="dropdown-item" @click="scheduleMaintenanceFor(property)">
                                        <i class="mdi mdi-wrench me-2"></i>Schedule Maintenance</a></li>
                                      <li><a class="dropdown-item" @click="generatePropertyReport(property)">
                                        <i class="mdi mdi-file-document me-2"></i>Generate Report</a></li>
                                      <li><hr class="dropdown-divider"></li>
                                      <li><a class="dropdown-item text-warning" @click="decommissionProperty(property)">
                                        <i class="mdi mdi-delete me-2"></i>Decommission</a></li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>

                          <!-- Loading State -->
                          <div v-if="loading" class="text-center p-5">
                            <div class="spinner-border text-info mb-3" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                            <h4>Loading Properties</h4>
                            <p>We are fetching the property data for you. Please wait...</p>
                          </div>

                          <!-- No Results -->
                          <div v-if="filteredProperties.length < 1 && !loading" class="text-center p-5">
                            <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                            <h4>No Properties Found</h4>
                            <p>Sorry, we could not find any properties that match your search or filter criteria.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Other tabs would have similar content filtered by type -->
                    <div class="tab-pane fade" id="market-stalls" role="tabpanel">
                      <!-- Market Stalls specific content -->
                    </div>
                    <div class="tab-pane fade" id="county-houses" role="tabpanel">
                      <!-- County Houses specific content -->
                    </div>
                    <div class="tab-pane fade" id="machinery" role="tabpanel">
                      <!-- Machinery specific content -->
                    </div>
                    <div class="tab-pane fade" id="equipment" role="tabpanel">
                      <!-- Equipment specific content -->
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <div class="d-flex align-items-center">
                        <span class="me-3">
                          Showing {{ (currentPage - 1) * pageSize + 1 }} to
                          {{ Math.min(currentPage * pageSize, filteredProperties.length) }}
                          of {{ filteredProperties.length }} entries
                        </span>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in visiblePages" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Property Details Modal -->
        <PropertyDetailsModal
            :property="selectedProperty"
            @edit-property="openPropertyModal"
            @allocate-property="allocateProperty"
        />

        <!-- Property Registration Modal -->
        <PropertyRegistrationModal
            :property="editingProperty"
            :isEditing="isEditing"
            @save-property="saveProperty"
        />

        <!-- Property Allocation Modal -->
        <PropertyAllocationModal
            :property="propertyToAllocate"
            @save-allocation="saveAllocation"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by  County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import PropertyDetailsModal from "@/components/properties/modals/PropertyDetailsModal.vue";
import PropertyRegistrationModal from "@/components/properties/modals/PropertyRegistrationModal.vue";
import PropertyAllocationModal from "@/components/properties/modals/PropertyAllocationModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "CountyPropertyManagement",
  components: {
    NavigationBar,
    PropertyDetailsModal,
    PropertyRegistrationModal,
    PropertyAllocationModal
  },
  data() {
    return {
      loading: false,
      search: '',
      currentPage: 1,
      pageSize: 10,

      // Filters
      filters: {
        propertyType: '',
        status: '',
        subCounty: '',
        ward: ''
      },

      // Filter options - Updated for  County
      subCounties: [
        'Imenti South', 'Imenti Central', 'Imenti North', 'Tigania West',
        'Tigania East', 'Igembe North', 'Igembe Central', 'Igembe South', 'Buuri'
      ],
      wards: [
        // Imenti South
        'Mitunguu', 'Igoki', 'Abothuguchi Central', 'Abothuguchi West', 'Kiagu', 'Nkuene',
        // Imenti Central
        'Mwanganthia', 'Abothuguchi East', 'Municipality', 'Kiagu', 'Kibirichia',
        // Imenti North
        'Timau', 'Municipality', 'Ntima East', 'Ntima West', 'Nyaki East', 'Nyaki West',
        // Tigania West
        'Athwana', 'Akithi', 'Kianjai', 'Nkomo', 'Mbeu',
        // Tigania East
        'Thangatha', 'Mikinduri', 'Kiguchwa', 'Muthara', 'Karama',
        // Igembe North
        'Antuambui', 'Ntunene', 'Antubetwe Kiongo', 'Naathu', 'Amwathi',
        // Igembe Central
        'Akirang\'ondu', 'Athiru Ruujine', 'Igembe East', 'Njia', 'Kangeta',
        // Igembe South
        'Maua', 'Kiegoi/Antubochiu', 'Athiru Gaiti', 'Akachiu', 'Kanuni',
        // Buuri
        'Timau', 'Kisima', 'Kiirua/Naari', 'Ruiri/Rwarera', 'Kibirichia'
      ],

      // Statistics
      statistics: {
        totalProperties: 3156,
        available: 942,
        allocated: 1823,
        maintenance: 334,
        decommissioned: 57,
        monthlyRevenue: 14780000
      },

      // Properties data - Updated for  County
      properties: [
        {
          id: 1,
          propertyId: "MRU-MS-001",
          name: " Central Market - Stall A1",
          description: "Prime corner stall in main market",
          type: "MARKET_STALL",
          subCounty: "Imenti Central",
          ward: "Municipality",
          specificLocation: " Central Market, Block A",
          size: "4m x 3m",
          condition: "Excellent",
          monthlyRate: 4500,
          status: "ALLOCATED",
          lastUpdated: "2025-01-15",
          registrationDate: "2020-03-15",
          currentOccupant: {
            name: "Grace Karimi Mwenda",
            phone: "+254712345678",
            businessType: "Vegetable Vendor",
            allocatedDate: "2023-06-01",
            leaseExpiry: "2026-05-31",
            monthlyPayment: 4500
          }
        },
        {
          id: 2,
          propertyId: "MRU-CH-001",
          name: "County Senior Staff House - Milimani",
          description: "4-bedroom house for senior county staff",
          type: "COUNTY_HOUSE",
          subCounty: "Imenti Central",
          ward: "Municipality",
          specificLocation: "Milimani Estate, County Staff Quarters",
          size: "4 Bedrooms, 200m²",
          condition: "Good",
          monthlyRate: 30000,
          status: "ALLOCATED",
          lastUpdated: "2025-01-10",
          registrationDate: "2018-11-20",
          currentOccupant: {
            name: "Dr. Paul Muthaura",
            phone: "+254723456789",
            designation: "County Health Director",
            allocatedDate: "2022-01-15",
            leaseExpiry: "2025-01-14",
            monthlyPayment: 30000
          }
        },
        {
          id: 3,
          propertyId: "MRU-MC-001",
          name: "Caterpillar Grader - CAT 140M",
          description: "Heavy duty motor grader for road construction",
          type: "MACHINERY",
          subCounty: "Imenti Central",
          ward: "Municipality",
          specificLocation: "County Workshop,  Town",
          size: "Heavy Machinery",
          condition: "Good",
          monthlyRate: 180000,
          status: "ALLOCATED",
          lastUpdated: "2025-01-12",
          registrationDate: "2019-05-10",
          currentOccupant: {
            name: "Meru Roads Construction Dept",
            phone: "+254734567890",
            allocatedDate: "2024-11-01",
            project: "Maua-Mikinduri Road Project",
            monthlyPayment: 180000
          }
        },
        {
          id: 4,
          propertyId: "MRU-EQ-001",
          name: "Water Bowser - 10,000L Capacity",
          description: "Water supply truck for community water programs",
          type: "EQUIPMENT",
          subCounty: "Imenti North",
          ward: "Timau",
          specificLocation: "Water Department Depot, Timau",
          size: "10,000 Liters",
          condition: "Excellent",
          monthlyRate: 50000,
          status: "AVAILABLE",
          lastUpdated: "2025-01-14",
          registrationDate: "2021-08-30",
          currentOccupant: null
        },
        {
          id: 5,
          propertyId: "MRU-MS-002",
          name: "Makutano Market - Stall B15",
          description: "Medium stall in Makutano market",
          type: "MARKET_STALL",
          subCounty: "Imenti South",
          ward: "Mitunguu",
          specificLocation: "Makutano Market, Block B",
          size: "3m x 3m",
          condition: "Good",
          monthlyRate: 3200,
          status: "ALLOCATED",
          lastUpdated: "2025-01-13",
          registrationDate: "2020-07-22",
          currentOccupant: {
            name: "David Muthomi Njeru",
            phone: "+254745678901",
            businessType: "Electronics Repair",
            allocatedDate: "2024-02-01",
            leaseExpiry: "2027-01-31",
            monthlyPayment: 3200
          }
        },
        {
          id: 6,
          propertyId: "MRU-VH-001",
          name: "Toyota Hilux - County Vehicle",
          description: "Double cabin pickup for field operations",
          type: "VEHICLE",
          subCounty: "Imenti Central",
          ward: "Municipality",
          specificLocation: "County Headquarters Motor Pool",
          size: "Double Cabin",
          condition: "Good",
          monthlyRate: 40000,
          status: "ALLOCATED",
          lastUpdated: "2025-01-11",
          registrationDate: "2020-02-14",
          currentOccupant: {
            name: "Agriculture Department",
            phone: "+254756789012",
            allocatedDate: "2024-09-01",
            driver: "Peter Kimathi Murungi",
            monthlyPayment: 40000
          }
        },
        {
          id: 7,
          propertyId: "MRU-CH-002",
          name: "County Junior Staff House - Gakoromone",
          description: "2-bedroom house for junior county staff",
          type: "COUNTY_HOUSE",
          subCounty: "Imenti Central",
          ward: "Municipality",
          specificLocation: "Gakoromone Estate, Staff Quarters",
          size: "2 Bedrooms, 100m²",
          condition: "Fair",
          monthlyRate: 15000,
          status: "MAINTENANCE",
          lastUpdated: "2025-01-08",
          registrationDate: "2017-04-18",
          currentOccupant: null
        },
        {
          id: 8,
          propertyId: "MRU-MC-002",
          name: "Water Drilling Rig - Atlas Copco",
          description: "Borehole drilling equipment",
          type: "MACHINERY",
          subCounty: "Tigania East",
          ward: "Mikinduri",
          specificLocation: "Water Department Yard, Mikinduri",
          size: "Heavy Machinery",
          condition: "Good",
          monthlyRate: 220000,
          status: "AVAILABLE",
          lastUpdated: "2025-01-09",
          registrationDate: "2021-03-25",
          currentOccupant: null
        },
        {
          id: 9,
          propertyId: "MRU-MS-003",
          name: "Maua Market - Stall C8",
          description: "Corner stall in Maua main market",
          type: "MARKET_STALL",
          subCounty: "Igembe South",
          ward: "Maua",
          specificLocation: "Maua Main Market, Block C",
          size: "5m x 4m",
          condition: "Excellent",
          monthlyRate: 5000,
          status: "ALLOCATED",
          lastUpdated: "2025-01-16",
          registrationDate: "2019-12-10",
          currentOccupant: {
            name: "Agnes Kawira Mutuma",
            phone: "+254767890123",
            businessType: "Miraa Trader",
            allocatedDate: "2023-03-15",
            leaseExpiry: "2026-03-14",
            monthlyPayment: 5000
          }
        },
        {
          id: 10,
          propertyId: "MRU-EQ-002",
          name: "Medical Equipment Set - Portable",
          description: "Mobile medical unit equipment",
          type: "EQUIPMENT",
          subCounty: "Buuri",
          ward: "Timau",
          specificLocation: "Health Department Store",
          size: "Portable Unit",
          condition: "Excellent",
          monthlyRate: 32000,
          status: "ALLOCATED",
          lastUpdated: "2025-01-05",
          registrationDate: "2022-06-15",
          currentOccupant: {
            name: "Mobile Health Unit Team",
            phone: "+254778901234",
            allocatedDate: "2024-07-01",
            supervisor: "Nurse Faith Gatwiri",
            monthlyPayment: 32000
          }
        }
      ],

      filteredProperties: [],
      selectedProperty: {},
      editingProperty: {},
      propertyToAllocate: {},
      isEditing: false,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    paginatedProperties() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredProperties.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredProperties.length / this.pageSize);
    },

    visiblePages() {
      const maxVisible = 5;
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= maxVisible) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 3; i <= total; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    }
  },
  watch: {
    search() {
      this.filterProperties();
    },
    pageSize() {
      this.currentPage = 1;
    }
  },
  mounted() {
    this.filteredProperties = [...this.properties];
    this.menuAccess();
  },
  methods: {
    getRight,

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(value);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-US').format(value);
    },

    formatPropertyType(type) {
      const typeMap = {
        'MARKET_STALL': 'Market Stall',
        'COUNTY_HOUSE': 'County House',
        'MACHINERY': 'Machinery',
        'EQUIPMENT': 'Equipment',
        'VEHICLE': 'Vehicle',
        'LAND': 'Land'
      };
      return typeMap[type] || type;
    },

    getPropertyTypeClass(type) {
      switch (type) {
        case 'MARKET_STALL':
          return 'bg-primary';
        case 'COUNTY_HOUSE':
          return 'bg-success';
        case 'MACHINERY':
          return 'bg-warning';
        case 'EQUIPMENT':
          return 'bg-info';
        case 'VEHICLE':
          return 'bg-secondary';
        case 'LAND':
          return 'bg-dark';
        default:
          return 'bg-secondary';
      }
    },

    getPropertyIcon(type) {
      switch (type) {
        case 'MARKET_STALL':
          return 'mdi mdi-store';
        case 'COUNTY_HOUSE':
          return 'mdi mdi-home';
        case 'MACHINERY':
          return 'mdi mdi-truck';
        case 'EQUIPMENT':
          return 'mdi mdi-tools';
        case 'VEHICLE':
          return 'mdi mdi-car';
        case 'LAND':
          return 'mdi mdi-map';
        default:
          return 'mdi mdi-cube';
      }
    },

    getPropertyIconClass(type) {
      switch (type) {
        case 'MARKET_STALL':
          return 'bg-primary';
        case 'COUNTY_HOUSE':
          return 'bg-success';
        case 'MACHINERY':
          return 'bg-warning';
        case 'EQUIPMENT':
          return 'bg-info';
        case 'VEHICLE':
          return 'bg-secondary';
        case 'LAND':
          return 'bg-dark';
        default:
          return 'bg-secondary';
      }
    },

    getStatusClass(status) {
      switch (status) {
        case 'AVAILABLE':
          return 'bg-success';
        case 'ALLOCATED':
          return 'bg-warning';
        case 'MAINTENANCE':
          return 'bg-info';
        case 'DECOMMISSIONED':
          return 'bg-danger';
        default:
          return 'bg-secondary';
      }
    },

    getPropertyCount(type) {
      return this.properties.filter(p => p.type === type).length;
    },

    gotTo(route) {
      router.push(route);
    },

    filterProperties() {
      let filtered = [...this.properties];

      // Filter by search
      if (this.search.trim()) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(property =>
            property.propertyId.toLowerCase().includes(searchTerm) ||
            property.name.toLowerCase().includes(searchTerm) ||
            property.description.toLowerCase().includes(searchTerm) ||
            property.specificLocation.toLowerCase().includes(searchTerm) ||
            (property.currentOccupant && property.currentOccupant.name.toLowerCase().includes(searchTerm))
        );
      }

      // Filter by type
      if (this.filters.propertyType) {
        filtered = filtered.filter(property => property.type === this.filters.propertyType);
      }

      // Filter by status
      if (this.filters.status) {
        filtered = filtered.filter(property => property.status === this.filters.status);
      }

      // Filter by sub county
      if (this.filters.subCounty) {
        filtered = filtered.filter(property => property.subCounty === this.filters.subCounty);
      }

      // Filter by ward
      if (this.filters.ward) {
        filtered = filtered.filter(property => property.ward === this.filters.ward);
      }

      this.filteredProperties = filtered;
      this.currentPage = 1;
    },

    viewPropertyDetails(property) {
      this.selectedProperty = property;
    },

    openPropertyModal(property = null) {
      this.isEditing = !!property;
      this.editingProperty = property ? { ...property } : {
        propertyId: '',
        name: '',
        description: '',
        type: 'MARKET_STALL',
        subCounty: '',
        ward: '',
        specificLocation: '',
        size: '',
        condition: 'Good',
        monthlyRate: 0,
        status: 'AVAILABLE'
      };

      const modalElement = document.getElementById('propertyRegistrationModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    openAllocationModal(property = null) {
      this.propertyToAllocate = property || {};

      const modalElement = document.getElementById('propertyAllocationModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    saveProperty(propertyData) {
      try {
        if (this.isEditing) {
          // Update existing property
          const index = this.properties.findIndex(p => p.id === propertyData.id);
          if (index > -1) {
            this.properties[index] = { ...propertyData, lastUpdated: moment().format('YYYY-MM-DD') };
            this.message = "Property updated successfully!";
          }
        } else {
          // Add new property
          const newId = Math.max(...this.properties.map(p => p.id)) + 1;
          propertyData.id = newId;
          propertyData.registrationDate = moment().format('YYYY-MM-DD');
          propertyData.lastUpdated = moment().format('YYYY-MM-DD');
          this.properties.unshift(propertyData);
          this.message = "Property registered successfully!";
        }

        this.alert.success = true;
        this.filterProperties();

        // Close modal
        const modalElement = document.getElementById('propertyRegistrationModal');
        if (modalElement) {
          const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }

        // Auto-hide alert
        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      } catch (e) {
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    allocateProperty(property) {
      this.propertyToAllocate = property;
      this.openAllocationModal(property);
    },

    saveAllocation(allocationData) {
      try {
        const property = this.properties.find(p => p.id === allocationData.propertyId);
        if (property) {
          property.status = 'ALLOCATED';
          property.currentOccupant = {
            name: allocationData.occupantName,
            phone: allocationData.occupantPhone,
            allocatedDate: allocationData.startDate,
            leaseExpiry: allocationData.endDate,
            monthlyPayment: property.monthlyRate,
            ...allocationData.additionalInfo
          };
          property.lastUpdated = moment().format('YYYY-MM-DD');

          this.message = `Property ${property.propertyId} allocated to ${allocationData.occupantName} successfully!`;
          this.alert.success = true;
          this.filterProperties();
        }

        // Close modal
        const modalElement = document.getElementById('propertyAllocationModal');
        if (modalElement) {
          const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }

        // Auto-hide alert
        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      } catch (e) {
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    terminateAllocation(property) {
      if (confirm(`Are you sure you want to terminate the allocation for ${property.propertyId}?`)) {
        property.status = 'AVAILABLE';
        property.currentOccupant = null;
        property.lastUpdated = moment().format('YYYY-MM-DD');

        this.message = `Allocation terminated for ${property.propertyId}`;
        this.alert.info = true;
        this.filterProperties();

        setTimeout(() => {
          this.alert.info = false;
          this.message = '';
        }, 3000);
      }
    },

    scheduleMaintenanceFor(property) {
      property.status = 'MAINTENANCE';
      property.lastUpdated = moment().format('YYYY-MM-DD');

      this.message = `Maintenance scheduled for ${property.propertyId}`;
      this.alert.info = true;
      this.filterProperties();

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    decommissionProperty(property) {
      if (confirm(`Are you sure you want to decommission ${property.propertyId}?`)) {
        property.status = 'DECOMMISSIONED';
        property.currentOccupant = null;
        property.lastUpdated = moment().format('YYYY-MM-DD');

        this.message = `${property.propertyId} has been decommissioned`;
        this.alert.info = true;
        this.filterProperties();

        setTimeout(() => {
          this.alert.info = false;
          this.message = '';
        }, 3000);
      }
    },

    generatePropertyReport(property) {
      this.message = `Generating report for ${property.propertyId}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    openBulkUpload() {
      this.message = "Bulk upload functionality will open here";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    openMaintenanceSchedule() {
      this.message = "Opening maintenance schedule management";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    generatePropertyReports() {
      this.message = "Generating comprehensive property reports...";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    // Pagination methods
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "County Property Registry");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.nav-tabs .nav-link {
  border-bottom: 2px solid transparent;
}

.nav-tabs .nav-link.active {
  border-bottom-color: #0d6efd;
  font-weight: 600;
}

.border {
  border-color: #dee2e6 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}
</style>